import { Deserializable } from './deserializable';
import { BaseModel } from './baseModel';
import { DateHelper } from '../util/dateHelper';
import { AliasOwnerRel } from './AliasOwnerRel';


export class UploadedFile extends BaseModel implements Deserializable {

  fileName: string;
  fileExt: string;
  fileData: string;

  fileUrl: string;

  description: string;

  contentType: string;
  
  deserialize(input: any) {

    super.deserialize(input);
    Object.assign(this, input);

    return this;
  }

}
